import { get } from 'lodash';
import { PressureActionTypes } from '~/actions/pressure';

const initialState = {
  data: null,
  isLoading: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PressureActionTypes.LOAD_PRESSURE:
      const seepageV2 = get(action, 'seepage_v2.data', []);
      if (seepageV2) {
        return {
          ...state,
          isLoading: false,
          data: seepageV2,
        };
      }

      return {
        ...state,
        data: null,
        isLoading: false,
      };

    case PressureActionTypes.RESET_IS_LOADING:
      return {
        ...state,
        isLoading: true,
        data: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/reducers/seepageV2.js